import React from 'react';

import {
  CloudSunRainSolidIcon,
  FlagCheckeredSolidIcon,
  MountainsSolidIcon,
  RoadSolidIcon,
  SnowflakeSolidIcon,
  SunSolidIcon,
  ThreePeakMountainLightIcon,
  TirePressureWarningSolidIcon
} from '../../../../shared/icons/icons';
import FuelEfficiencyImage from '../fuel-efficiency-image/fuel-efficiency-image';

import { TIRE_ATTIBUTES } from '../../../../shared/constants/products';

import './tire-attribute-icon.scss';

interface TireAttributeIconProps {
  className?: string;
  name: string;
}

const TIRE_ATTRIBUTE_ICON_MAP = {
  [TIRE_ATTIBUTES.ALL_SEASON]: {
    icon: CloudSunRainSolidIcon
  },
  [TIRE_ATTIBUTES.ALL_TERRAIN]: {
    icon: MountainsSolidIcon
  },
  [TIRE_ATTIBUTES.COMPETION]: {
    icon: FlagCheckeredSolidIcon
  },
  [TIRE_ATTIBUTES.PERFORMANCE]: {
    icon: FlagCheckeredSolidIcon
  },
  [TIRE_ATTIBUTES.RUN_FLAT]: {
    icon: TirePressureWarningSolidIcon
  },
  [TIRE_ATTIBUTES.SUMMER]: {
    icon: SunSolidIcon
  },
  [TIRE_ATTIBUTES.TOURING]: {
    icon: RoadSolidIcon
  },
  [TIRE_ATTIBUTES.TREADWELL_FUEL_EFFICIENT]: {
    icon: FuelEfficiencyImage
  },
  [TIRE_ATTIBUTES.WINTER]: {
    icon: SnowflakeSolidIcon
  },
  [TIRE_ATTIBUTES.THREE_PEAK_MOUNTAIN]: {
    icon: ThreePeakMountainLightIcon
  }
};

function TireAttributeIcon(props: TireAttributeIconProps) {
  const { className, name } = props;

  const Icon = TIRE_ATTRIBUTE_ICON_MAP[name]?.icon;

  return <Icon className={className} styleName="icon" />;
}

export default TireAttributeIcon;
